<template>
  <svg
    class="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="14 10 71.5 71.5"
    enable-background="new 14 10 71.5 71.5"
    xml:space="preserve"
  >
    <g>
      <path
        d="M72.588,21.612C66.706,15.729,58.706,12.2,50.235,12.2s-16.471,3.294-22.353,9.412C17.765,31.729,15.412,46.553,22,59.024
		l4.235-2.118c-5.647-10.588-3.529-23.294,4.941-31.765c4.706-5.176,11.529-8,18.824-8s14.118,2.824,19.059,8
		c5.176,5.176,8,12,8,19.059s-2.824,14.118-8,19.059c-8.471,8.471-21.176,10.353-31.765,4.941l-1.882,4.235
		c4.706,2.353,9.647,3.529,14.824,3.529c8.235,0,16.235-3.294,22.353-9.412C78.471,60.671,82,52.671,82,44.2
		S78.471,27.729,72.588,21.612z"
      />
      <polygon
        points="55.882,53.612 60.588,53.612 60.588,33.612 40.588,33.612 40.588,38.318 52.588,38.318 26.235,64.435
		29.765,67.965 55.882,41.612 	"
      />
    </g>
  </svg>
</template>

<script>
  export default {};
</script>
